module.exports = __webpack_public_path__ + "static/img/logo24.6df639f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo24.png
// module id = WvYZ
// module chunks = 1